import React, { useState } from 'react';
import { HardDrive, Clock, History } from 'lucide-react';
import NASConfigForm from './NASConfigForm';
import BackupScheduleForm from './BackupScheduleForm';
import BackupHistoryTable from './BackupHistoryTable';

const BackupSettings: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'nas' | 'schedule' | 'history'>('nas');

  const tabs = [
    { id: 'nas' as const, label: 'NAS Connection', icon: HardDrive },
    { id: 'schedule' as const, label: 'Backup Schedule', icon: Clock },
    { id: 'history' as const, label: 'Backup History', icon: History },
  ];

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-white shadow rounded-lg p-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          NAS Backup Settings
        </h1>
        <p className="text-gray-600">
          Configure automated backup to external NAS storage (Synology/QNAP)
        </p>
      </div>

      {/* Tabs */}
      <div className="bg-white shadow rounded-lg">
        <div className="border-b border-gray-200">
          <nav className="flex -mb-px">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`
                    flex items-center px-6 py-4 border-b-2 font-medium text-sm transition-colors
                    ${
                      activeTab === tab.id
                        ? 'border-blue-500 text-blue-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }
                  `}
                >
                  <Icon className="w-5 h-5 mr-2" />
                  {tab.label}
                </button>
              );
            })}
          </nav>
        </div>

        {/* Tab Content */}
        <div className="p-6">
          {activeTab === 'nas' && <NASConfigForm />}
          {activeTab === 'schedule' && <BackupScheduleForm />}
          {activeTab === 'history' && <BackupHistoryTable />}
        </div>
      </div>
    </div>
  );
};

export default BackupSettings;
